import { render, staticRenderFns } from "./DefectsTableTab.vue?vue&type=template&id=bb2addba&scoped=true&"
import script from "./DefectsTableTab.vue?vue&type=script&lang=ts&"
export * from "./DefectsTableTab.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb2addba",
  null
  
)

export default component.exports